import { useIonPopover } from '@ionic/react';
import { canUserDeletePostComment, FullComment, FullPost } from 'model';
import React from 'react';
import { ReactElement } from 'react-markdown/lib/react-markdown';
import { useSelector } from 'react-redux';
import { useGetCommentReportsQuery } from '../api/ReportApi';
import { RootState } from '../App';
import { LoginState } from '../state/loginSlice';
import { BlockUser } from './BlockUser';
import { DeleteComment } from './DeleteComment';

import { ReportComment } from './ReportComment';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { IconButton } from './IconButton';
import { IconMoreHorizontal } from './QuirkIcons';
import { RequestRevision } from './RequestRevision';
interface MenuProps {
	comment: FullComment;
	post: FullPost;
	editButton?: ReactElement | null;
}

export const CommentMenu: React.FC<MenuProps> = ({ comment, post, editButton }) => {
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);

	const commentid = comment._id;
	const commentauthorid = comment.author;
	const postauthorid = post.author;
	const userid = state.user._id;

	const didIReportThisComment = useGetCommentReportsQuery(commentid);
	const isReported = !!didIReportThisComment?.data?._id;
	const [show, hide] = useIonPopover(
		<div className={sharedStyles.popMenu}>
			{userid !== commentauthorid && (
				<ReportComment comment={comment} isReported={isReported} hideTooltip={() => hide()} label={true} />
			)}

			{canUserDeletePostComment(state.user, comment, post) && (
				<DeleteComment comment={comment} action={() => hide()} label="Delete Comment" />
			)}
			{editButton && <div onClick={() => hide()}>{editButton}</div>}
			{postauthorid === userid && comment.fullAuthor._id !== userid && comment.commentModerationReason === '' && (
				<RequestRevision comment={comment} label="Request Revision" action={() => hide()} />
			)}
			{postauthorid === userid && (
				<BlockUser userToBlock={comment.fullAuthor} type="menu" action={() => hide()} />
			)}
		</div>
	);

	return (
		<div className={sharedStyles.menuIconContainer}>
			<IconButton icon={<IconMoreHorizontal />} onClick={(e: any) => show({ event: e })} />
		</div>
	);
};
